<template>
    <div>
      <OrderDetailPopUp :appOrder="appOrder" :isModal="false" />
    </div>
</template>
<script>
import { KAKAO_PAGE_NAME, APP_INSTALLATION_INDUCE_NAME } from '@/utils/EndPoint'
import { REQ_KAKAO_ORDER } from '@/store/_actions/actionTypes'
import OrderDetailMixin from '@/utils/OrderDetailMixin'
import OrderDetailPopUp from '@/components/PopUp/OrderDetailPopUp.vue'

export default {
  name: KAKAO_PAGE_NAME,
  mixins: [OrderDetailMixin],
  components: { OrderDetailPopUp },
  data () {
    return {
      beforeWeek: null,
      detailUrl: ''
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    async initData () {
      const storeGroupCode = this.$store.getters.storeGroupCode
      const orderCode = this.$route.query.orderCode
      if (orderCode) {
        const order = {
          pageNumber: this.pageNumber,
          storeCode: storeGroupCode,
          storeGroupCode: storeGroupCode,
          userCode: this.$store.getters.userCode,
          orderCode: this.$route.query.orderCode
        }
        await this.orderListDetail(order)
        await this.reqOrderKaKao()
      } else { // 뒤로가기 case
        this.checkAndShowOrder()
      }
    },
    reqOrderKaKao () {
      this.$store.dispatch(REQ_KAKAO_ORDER, this.$route.query.orderCode)
        .then((responsedData) => {
          this.beforeWeek = responsedData.beforeWeek
          this.detailUrl = responsedData.detailUrl
        })
    }
  },
  watch: {
    beforeWeek () {
      if (this.beforeWeek && this.userAgent === 'mobile') {
        // 7일 경과 && 웹
        this.$router.replace({ name: APP_INSTALLATION_INDUCE_NAME, query: { url: this.detailUrl } })
      }
    }
  }
}
</script>
